export default function IncompleteProfil({className}){
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50" class={`MuiSvgIcon-root ${className}`}>
      <g id="Profil_incomplet" data-name="Profil incomplet" transform="translate(23874 19268)">
        <rect id="rectangle" width="50" height="50" transform="translate(-23874 -19268)" fill="none"/>
        <g id="Profil_incomplet-2" data-name="Profil incomplet" transform="translate(-398.894 809.609)">
          <g id="person_black_24dp" transform="translate(-23472.736 -20077.32)">
            <path id="Tracé_13958" data-name="Tracé 13958" d="M0,0H45.26V45.26H0Z" fill="none"/>
            <path id="Tracé_13959" data-name="Tracé 13959" d="M22.63,27.287C16.412,27.287,4,30.408,4,36.6v2.329A2.336,2.336,0,0,0,6.329,41.26h32.6a2.336,2.336,0,0,0,2.329-2.329V36.6C41.26,30.408,28.848,27.287,22.63,27.287Z" fill="#75a8fb"/>
            <circle id="Ellipse_712" data-name="Ellipse 712" cx="11" cy="11" r="11" transform="translate(22.736 27.422)" fill="#fff"/>
            <path id="blind-eyes-svgrepo-com" d="M99.529,88.128a2.289,2.289,0,0,0-3.237,0l-2.96,2.96-2.96-2.96a2.289,2.289,0,1,0-3.237,3.237l2.96,2.96-2.96,2.96a2.289,2.289,0,1,0,3.237,3.237l2.96-2.96,2.96,2.96a2.289,2.289,0,1,0,3.237-3.237l-2.96-2.96,2.96-2.96A2.289,2.289,0,0,0,99.529,88.128Z" transform="translate(-59.254 -55.666)" fill="#0060f9"/>
            <path id="Tracé_14119" data-name="Tracé 14119" d="M22.63,22.63a9.315,9.315,0,1,0-9.315-9.315A9.312,9.312,0,0,0,22.63,22.63Z" fill="#0060f9"/>
          </g>
        </g>
      </g>
    </svg>
  )
}


